var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C85A7",
    fillRule: "evenodd",
    d: "M11.2 12.557H9.1v-1.876c0-.558-.45-1.01-.996-1.01H5.895c-.55 0-.995.451-.995 1.01v1.876H2.8V5.93l4.193-4.321 4.206 4.335v6.614zM7.697.29a.963.963 0 0 0-1.394 0L.697 6.062a1.04 1.04 0 0 0 0 1.437l.29.3.413-.427v5.621c0 .556.452 1.007.991 1.007h2.917a1 1 0 0 0 .992-1.01v-1.876h1.4v1.877c0 .557.452 1.009.991 1.009h2.917c.547 0 .991-.455.991-1.005v-5.61l.41.422.292-.3c.386-.398.39-1.04.002-1.438L7.698.289z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon_address.979b7abb0ebfb0d439d208b667e36efe.svg";
export { ForwardRef as ReactComponent };